import React, { useState, useEffect } from "react";
import axios from "axios";
import MenuItem from "./MenuItem";
import MenuSection from "./MenuSection";
import { useCart } from "../CartContext";
import { FaAngleDoubleDown } from "react-icons/fa";
import { SnackbarProvider, enqueueSnackbar } from "notistack";
import Orders from "./Orders";
import { IoCloseCircle } from "react-icons/io5";
import useTranslation from "./customHooks/translations";
import { IoClose } from "react-icons/io5";
import { ShopInfo } from "../shopinfo";
import confetti from "canvas-confetti";
import { _post } from "../services/apiClient";
import { _put } from "../services/apiClient";
import { _get } from "../services/apiClient";
import { useNavigate } from "react-router-dom";
import { _fetch } from "../services/apiClient";
import { Container, Row, Col, Button, Table } from "react-bootstrap";
import { jwtDecode } from "jwt-decode";
import { formatCurrency } from "../helper/currency";

//import { stringToColor } from '../../../shared/colorUtils';

const CartBox = ({
  cart,
  setCart,
  cartVisible,
  form,
  setForm,
  setCartVisible,
  size,
  phoneNumber,
  setPageVisible,
  pageVisible,
  loggedIn,


}) => {
  const {
    updateQuantity,
    itemQuantities,
    updateTotalPrice,
    resetTotalPrice,
    totalPrice,
    setTotalPrice,
  } = useCart();

  const variantCount = Object.values(itemQuantities || {}).filter(
    (v) => (v?.quantity || 0) > 0
  ).length;

  const [showForm, setShowForm] = useState(false);
  const [show, setShow] = useState(true);
  const [text, setText] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [orderSummary, setOrderSummary] = useState([]);
  const [showFeedbackPage, setShowFeedbackPage] = useState(false);
  const [feedback, setFeedback] = useState({});
  const [orderId, setOrderId] = useState("");
  const toPay = parseFloat(totalPrice) || 0;
  const [hasCustomerInfo, setHasCustomerInfo] = useState(false);
  const [showPlacedOrderSummary, setShowPlacedOrderSummary] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showOrderSummary, setShowOrderSummary] = useState(true);
  const navigate = useNavigate();
  const [customerOrders, setCustomerOrders] = useState([]);
  const [order, setOrder] = useState(null);

  const [recentAddresses, setRecentAddresses] = useState([]);

  const [jwtUser, setJwtUser] = useState(null);
  const [terms, setTerms] = useState(null);
  const [stockErrors, setStockErrors] = useState([]);


  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const decoded = jwtDecode(token);

      setJwtUser(decoded);

      if (decoded?.id) {
        const fetchUserDetails = async () => {
          try {
            const res = await _get(`/auth/me/${decoded.id}`);
            if (res.data.success) {
              setForm((prev) => ({
                ...prev,
                userId: decoded.id,
                phoneNumber: res.data.user.phoneNumber || "",
                name: res.data.user.name || '',
                email: res.data.user.email || ''
              }));
            }
          } catch (err) {
            console.error("Failed to fetch user:", err);
          }
        };

        const fetchRecentAddresses = async () => {
          try {
            const response = await _get(`/orders/address/${decoded.id}`);
            const addresses = response.data || [];
            // console.log("Recent addresses:", addresses);
            setRecentAddresses(addresses);
          } catch (err) {
            console.error("Failed to fetch recent addresses:", err);
          }
        };

        fetchUserDetails();
        fetchRecentAddresses();
      }
    } catch (err) {
      console.error("Invalid JWT:", err);
    }
  }, [setForm, setRecentAddresses]);


  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const res = await _get("/orders/terms");
        setTerms(res.data);
      } catch (err) {
        console.error("Error fetching terms:", err);
      }
    };
    fetchTerms();
  }, []);


  useEffect(() => {
    const anyModalOpen = cartVisible || !show || showFeedbackPage;
    if (anyModalOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => document.body.classList.remove("modal-open");
  }, [cartVisible, show, showFeedbackPage]);

  useEffect(() => {
    if (!orderId) {
      console.warn("⚠️ No orderId available.");
      return;
    }


    const fetchOrder = async () => {
      try {
        const response = await axios.get(`/api/orders/${orderId}`);
        setOrderSummary(response.data);
        setShowPlacedOrderSummary(true);
      } catch (err) {
        console.error("Error fetching order:", err);
      }
    };

    fetchOrder();
  }, [orderId]);

  const triggerConfetti = () => {
    confetti({
      particleCount: 500,
      spread: 500,
      origin: { y: 0.6 },
      colors: ["#ff0", "#f00", "#0f0", "#00f", "#f0f"],
    });
  };

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("customerInfo"));
    if (storedData?.name?.trim() && storedData?.mobile?.trim()) {
      setHasCustomerInfo(true);
    }
  }, []);
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);

  const handlePlaceOrder = async () => {
    if (!form.phoneNumber || form.phoneNumber.length !== 10 || !/^\d{10}$/.test(form.phoneNumber)) {
      enqueueSnackbar("Please enter a valid 10-digit mobile number", { variant: "error" });
      return;
    }

    if (!form.houseNo?.trim()) {
      enqueueSnackbar("Please enter House / Flat No.", { variant: "error" });
      return;
    }

    if (!form.area?.trim()) {
      enqueueSnackbar("Please enter Area", { variant: "error" });
      return;
    }

    if (!form.pincode || form.pincode.length !== 6 || !/^\d{6}$/.test(form.pincode)) {
      enqueueSnackbar("Please enter a valid 6-digit Pincode", { variant: "error" });
      return;
    }

    setIsPlacingOrder(true);

    const success = await PlaceOrderInWhatsapp();

    //  Only show summary if order succeeded
    if (success) {
      if (!hasCustomerInfo) {
        setShow(false);
        setCartVisible(false);
      }
      setShowPlacedOrderSummary(true);
    }

    setIsPlacingOrder(false);
  };


  const translation = useTranslation();
  // console.log('cartv', cartVisible);
  const removeItem = (_id) => {
    const removedItem = cart.find((item) => item._id === _id);
    const updatedCart = cart.filter((item) => item._id !== _id);
    setCart(updatedCart);
    localStorage.setItem("cartValue", JSON.stringify(updatedCart));
    //{ removedItem.OfferDescription ? updateTotalPrice(-(removedItem.price)) : updateTotalPrice(-removedItem.price) };
  };
  const handleShow = () => {
    setShowForm(true);
  };
  const handleShowCart = () => {
    setShow(false);
  };
  const handlehideCart = () => {
    setShow(true);
  };

  const handleCloseClick = () => {
    // console.log("button is clicked", cartVisible);
    setCartVisible(false);
    //window.location.reload();
  };

  const handleFormChange = (e) => {
    const { id, value } = e.target;
    setForm((prevData) => ({ ...prevData, [id]: value }));
  };
  const handleText = (e) => {
    setText(e.target.value);
  };
  const handleTextSubmit = () => {
    const { message } = text;
    setText("");
    enqueueSnackbar(`Thank you for your Suggestion !`, { variant: "success" });
  };

  const handleFormSubmit = () => {
    const { name, phoneNumber, email, address } = form;

    if (!name || !phoneNumber || !email || !address) {
      setShowForm(true);
      setShow(false);

      enqueueSnackbar(`Please fill in all required fields.`, {
        variant: "error",
      });
    } else {
      enqueueSnackbar(`Thank you ${name} for your Order !`, {
        variant: "success",
      });
      setForm({
        name: "",
        phoneNumber: "",
        email: "",
        address: "",
      });
      setShowForm(false);
      handlePostClick();
      setCart([]);
      localStorage.setItem("cartValue", []);
      resetTotalPrice();
      setShow(true);
    }
  };
  useEffect(() => {
    const newTotalPrice = cart.reduce((total, item) => {
      const variant = item.variants?.[0];
      const price = variant?.offerPrice || variant?.price;
      return (
        total +
        (variant?.price || 0) * (itemQuantities[item._id]?.quantity || 1)
      );
    }, 0);

    setTotalPrice(newTotalPrice);
  }, [cart, itemQuantities]);

  const handleClose = () => {
    setCartVisible(false);
  };


  const gstRate = ShopInfo.gstRate;

  const calculateTotal = () => {
    return Object.values(itemQuantities).reduce((acc, item) => {
      if (!item?.variant) return acc; // Skip if no variant data
      const price = item.variant.offerPrice
        ? parseFloat(item.variant.offerPrice)
        : parseFloat(item.variant.price || 0);
      const quantity = item.quantity || 0;
      return acc + price * quantity;
    }, 0);
  };

  const itemTotal = parseFloat(calculateTotal().toFixed(2));
  const gstAmount = parseFloat((itemTotal * gstRate).toFixed(2));
  const totalWithGST = parseFloat((itemTotal + gstAmount).toFixed(2));
  const localStorageUser = JSON.parse(localStorage.getItem("user"));

  const PlaceOrderInWhatsapp = async () => {
    try {
      setStockErrors([]); // Clear previous errors
      if (!cart.length) {
        enqueueSnackbar("Cart is empty. Please add items!", { variant: "warning" });
        return false;
      }

      const token = localStorage.getItem("token");
      let jwtUser = null;
      if (token) {
        try {
          jwtUser = jwtDecode(token);
        } catch (err) {
          console.error("Invalid JWT:", err);
        }
      }

      const customerInfo = JSON.parse(localStorage.getItem("customerInfo")) || {};
      const lastCustomer = JSON.parse(localStorage.getItem("lastCustomerInfo")) || {};
      const isDineIn = !!customerInfo && Object.keys(customerInfo).length > 0;

      let dineSessionId = localStorage.getItem("dineSessionId");

      if (
        customerInfo.name !== lastCustomer.name ||
        customerInfo.phoneNumber !== lastCustomer.phoneNumber
      ) {
        dineSessionId = Date.now().toString();
        localStorage.setItem("dineSessionId", dineSessionId);
        localStorage.setItem("lastCustomerInfo", JSON.stringify(customerInfo));
      }

      const products = Object.values(itemQuantities)
        .filter((item) => item.quantity > 0)
        .map((item) => {
          const { productId, variant, quantity } = item;
          const product = cart.find((p) => p._id === productId);
          const price = variant?.offerPrice || variant?.price || 0;

          return {
            productId,
            variantId: variant?._id || variant?.id || null,
            productTitle: `${product?.productName || "Unknown"} - ${variant?.quantity || "N/A"} ${variant?.unit || ""}`,
            quantity,
            price,
            images: product?.images || [],
            subTotal: quantity * price,
          };
        });

      // Validate stock before placing order
      if (!isDineIn) {
        try {
          const stockValidation = await _post("/orders/validate-stock", { products });

          if (!stockValidation.data.success) {
            //  Store complete error objects with productTitle, requested, available
            setStockErrors(stockValidation.data.outOfStockItems);
            return false; 
          }
        } catch (validationError) {
          if (validationError.response?.data?.outOfStockItems) {
            setStockErrors(validationError.response.data.outOfStockItems);
            return false;
          }
          setStockErrors([{
            productTitle: "System Error",
            requested: "-",
            available: "Unable to validate stock. Please try again!"
          }]);
          return false;
        }
      }

      const combinedAddress = [form.houseNo, form.area, form.landmark]
        .filter((part) => part && part.trim() !== "")
        .join(", ");

      const endpoint = isDineIn ? "/orders/dinein" : "/orders/create";

      const orderData = isDineIn
        ? {
          name: customerInfo.name,
          phoneNumber: customerInfo.mobile,
          tableNumber: customerInfo.tableNo,
          products,
          totalAmount: totalWithGST,
          sessionId: dineSessionId,
        }
        : {
          name: jwtUser?.name || form.name,
          phoneNumber: jwtUser?.phoneNumber || form.phoneNumber,
          address: combinedAddress,
          pincode: form.pincode,
          sessionId: dineSessionId,
          amount: totalWithGST,
          paymentId: "111",
          email: jwtUser?.email || form.email,
          userid: loggedIn ? jwtUser?.id || "USER1" : "guest",
          products,
        };

      const response = await _post(endpoint, orderData);

      if (response.status === 201 && response.data.success) {
        const order = response.data.order || response.data;
        if (isDineIn && response.data.sessionId) {
          localStorage.setItem("dineSessionId", response.data.sessionId);
        }

        const orderId = response.data.orderId || response.data.order?._id;
        if (!orderId) {
          setStockErrors([{
            productTitle: "Order Processing Error",
            requested: "-",
            available: "Unable to process order. Please try again!"
          }]);
          return false;
        }

        sessionStorage.setItem("OrderId", orderId);

        if (isDineIn) {
          setOrder(order);
          setOrderSummary(response.data.products || []);
        } else {
          setOrder(null);
          setOrderSummary(cart);
        }

        setCart([]);
        localStorage.removeItem("cartValue");
        localStorage.removeItem("cartQuantityValue");

        enqueueSnackbar("Order placed successfully!", { variant: "success" });

        setTimeout(() => {
          window.location.href = "/";
        }, 5000);

        return true; 
      }

      return false;
    } catch (error) {
      if (error.response?.data?.outOfStockItems) {
       
        setStockErrors(error.response.data.outOfStockItems);
      } else {
        setStockErrors([{
          productTitle: "Order Error",
          requested: "-",
          available: "Error placing order. Please try again!"
        }]);
      }

      return false;
    }
  };


  const addItemToCart = (item) => {
    const updatedCart = [...cart, item];
    setCart(updatedCart);
    localStorage.setItem("cartValue", JSON.stringify(updatedCart));

    const newTotalPrice = updatedCart.reduce((total, cartItem) => {
      const variant = cartItem.variants?.[0];

      return (
        total +
        (variant?.price || 0) * (itemQuantities[cartItem._id]?.quantity || 1)
      );
    }, 0);

    setTotalPrice(newTotalPrice);
  };

  const handlePostClick = async () => {
    try {
      const response = await axios.post("http://localhost:3000/api/cart", {
        phoneNumber: form.phoneNumber,
        items: cart.map((item) => ({
          name: item.productName,
          _id: item._id,
          quantity: itemQuantities[item._id]?.quantity || 0,
          price: itemQuantities[item._id]?.price,
          image: item.imageUrl,
        })),
        message: text,

        totalPrice: totalWithGST,
      });

      // console.log("Order placed successfully:", response.data);

      localStorage.removeItem("cartValue");
      setCart([]);

      localStorage.setItem("cartValue", JSON.stringify([]));
      if (
        setForm({
          name: "",
          phoneNumber: "",
          email: "",
          address: "",
        })
      ) {
        setShowForm(true);
      } else {
        setShowForm(false);
      }
    } catch (error) {
      console.error("Error placing order:", error);
      enqueueSnackbar("Failed to place order. Please try again later.", {
        variant: "error",
      });
    }
  };
  const handleOrderRefresh = async () => {
    const dineSessionId = localStorage.getItem("dineSessionId");

    if (!dineSessionId) return;

    try {
      console.log("Calling API: /orders/dinein/" + dineSessionId);
      const res = await _get(`/orders/dinein/${dineSessionId}`);

      console.log("Raw response:", res);

      const data = res.data;
      console.log("Parsed data:", data);

      if (data.order) {
        setOrder(data.order);
        setOrderSummary(data.order.products);
      }
    } catch (err) {
      console.error("Failed to refresh order:", err);
    }
  };

  const handleRatingChange = (productId, rating) => {
    setFeedback((prev) => ({
      ...prev,
      [productId]: {
        ...prev[productId],
        rating,
        comment: prev[productId]?.comment || "",
      },
    }));
  };
  const [isBillSettled, setIsBillSettled] = useState(false);

  const handleCommentChange = (productId, comment) => {
    setFeedback((prev) => ({
      ...prev,
      [productId]: { ...prev[productId], comment },
    }));
  };
  const handleSubmitFeedback = async () => {
    setIsSubmitting(true);

    try {
      const orderId = sessionStorage.getItem("OrderId") || "Unknown";

      const feedbackArray = Object.keys(feedback).map((productId) => ({
        productId,
        productName:
          orderSummary.find((item) => item._id === productId)?.productName ||
          "Unknown",
        rating: feedback[productId]?.rating || 0,
        comment: feedback[productId]?.comment?.trim() || "",
      }));

      const invalidFeedback = feedbackArray.some(
        (item) => item.rating < 3 && item.comment === ""
      );

      if (invalidFeedback) {
        enqueueSnackbar("Please provide a comment for ratings below 3 stars.", {
          variant: "error",
        });
        return;
      }

      const requestData = {
        orderId,
        userId: orderSummary[0]?.userId || "Unknown",
        feedbacks: feedbackArray,
      };

      await _post("/orders/feedback", requestData);

      enqueueSnackbar("Feedback submitted successfully!", {
        variant: "success",
      });
      setShowFeedbackPage(false);
    } catch (error) {
      console.error("Error submitting feedback:", error);
      enqueueSnackbar("Failed to submit feedback.", { variant: "error" });
    }
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleSettleBill = async () => {
    try {
      const response = await _put(`/orders/settle-bill/${order._id}`);

      setIsBillSettled(true);
      setIsModalVisible(true);
    } catch (error) {
      console.error("Error settling bill:", error);
    }
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  return (
    <SnackbarProvider>
      {cartVisible && (

        <div
          className="col-md-6 col-lg-12 col-4 border border-4 border-black mt-0 translate-middle mt-20 container position-absolute"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="cartBoxLabel"

        >
          <div
            className="modal-dialog mt-5 mx-auto shadow-lg border border-4 border-black"
            role="document"
            style={{ zIndex: 1200, top: "-35px" }}
          >
            <div
              className="modal-content shadow-lg border border-4 border-black"
              style={{ maxHeight: "80vh", overflowY: "auto" }}
            >
              <div className="modal-content shadow-lg border border-4 border-black">
                <div className="modal-header">
                  <h5 className="modal-title" id="cartBoxLabel">
                    <a href="#" className="brand-wrap mb-0 text-dark">
                      GoDigex Mart
                      <img
                        alt="#"
                        className="img-fluid"
                        src={window.location.origin + "/img/logo_web.png"}
                      />
                    </a>
                  </h5>
                  <div
                    className="px-2 pb-5"
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "10px",
                      fontSize: "20px",
                    }}
                  >
                    <span>
                      <IoClose
                        onClick={() => {
                          setPageVisible(false);
                          setCartVisible(false);
                        }}
                      />
                    </span>
                  </div>
                </div>

                <div className="modal-body">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12 col-lg-12 col-12 order-md-last">
                        <h4 className="d-flex justify-content-between align-items-center mb-3">
                          <span className="text-primary">
                            {translation.yourcart}
                          </span>
                          <span className="badge bg-primary rounded-pill">
                            {variantCount}
                          </span>
                        </h4>
                        {variantCount > 0 && (
                          <ul className="list-group mb-3">

                            {Object.keys(itemQuantities).map((cartKey) => {
                              const cartItem = itemQuantities[cartKey];
                              const productId = cartItem.productId;
                              const variant = cartItem.variant;
                              const cartQuantity = cartItem.quantity;


                              if (cartQuantity === 0) return null;


                              const product = cart.find(item => item._id === productId);
                              if (!product) return null;

                              const price = variant?.offerPrice || variant?.price;

                              return (
                                <li
                                  key={cartKey}
                                  className="list-group-item d-flex align-items-center"
                                  style={{
                                    gap: "12px",
                                    padding: "10px 12px",
                                    borderRadius: "6px",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {/* Product Name */}
                                  <div
                                    className="flex-grow-1"
                                    style={{
                                      minWidth: 0,
                                      overflow: "hidden",
                                      display: "-webkit-box",
                                      WebkitLineClamp: 2,
                                      WebkitBoxOrient: "vertical",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "normal",
                                      fontSize: "14px",
                                      lineHeight: "1.4em",
                                    }}
                                    title={product.productName}
                                  >
                                    {product.productName}
                                    {variant && (
                                      <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
                                        {variant.quantity} {variant.unit}
                                      </div>
                                    )}
                                  </div>

                                  <div
                                    className="d-flex align-items-center"
                                    style={{
                                      flexShrink: 0,
                                      gap: "12px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >

                                    <div className="btn-group" role="group" aria-label="Quantity">
                                      <button
                                        type="button"
                                        className="btn-sm btn btn-outline-secondary"
                                        onClick={() => {
                                          const newQuantity = cartQuantity - 1;
                                          updateQuantity(
                                            productId,
                                            newQuantity,
                                            variant?.price,
                                            variant?.offerPrice,
                                            variant
                                          );


                                          if (newQuantity === 0) {

                                            const hasOtherVariants = Object.keys(itemQuantities).some(key => {
                                              if (key === cartKey) return false;
                                              const item = itemQuantities[key];
                                              return item.productId === productId && item.quantity > 0;
                                            });

                                            if (!hasOtherVariants) {
                                              removeItem(productId);
                                            }
                                          }
                                        }}
                                      >
                                        <i className="feather-minus"></i>
                                      </button>

                                      <span
                                        className="btn-sm btn btn-outline-secondary"
                                        style={{
                                          minWidth: 36,
                                          textAlign: "center",
                                        }}
                                      >
                                        {cartQuantity}
                                      </span>

                                      <button
                                        type="button"
                                        className="btn-sm btn btn-outline-secondary"
                                        onClick={() => {
                                          // ✅ Prevent exceeding available stock
                                          if (cartQuantity >= variant?.availableStock) {
                                            enqueueSnackbar(`Only ${variant?.availableStock} available in stock`, {
                                              variant: "warning",
                                            });
                                            return;
                                          }

                                          const newQuantity = cartQuantity + 1;
                                          updateQuantity(
                                            productId,
                                            newQuantity,
                                            variant?.price,
                                            variant?.offerPrice,
                                            variant
                                          );
                                        }}
                                      >

                                        <i className="feather-plus"></i>
                                      </button>
                                    </div>


                                    <span
                                      className="text-body-secondary fw-bold fs-6"
                                      style={{
                                        minWidth: 90,
                                        textAlign: "right",
                                        display: "inline-block",
                                      }}
                                    >
                                      {formatCurrency(price * cartQuantity)}
                                    </span>
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        )}

                        {!hasCustomerInfo && (
                          <>
                            <hr />
                            {/* Display for Item Total, GST, and Final Total */}
                            <div className="d-flex justify-content-between mb-3">
                              <span>{translation.ItemTotal}</span>
                              <span>{formatCurrency(itemTotal)}</span>
                            </div>


                            <div className="d-flex justify-content-between mb-3">
                              <span>
                                {translation.GST} ({(gstRate * 100).toFixed(0)}%)
                              </span>
                              <span>{formatCurrency(gstAmount)}</span>
                            </div>


                            <hr />
                            <div>
                              <h6 className="font-weight-bold mb-0">
                                {translation.TOPAY}
                                <span className="float-right">
                                  {formatCurrency(totalWithGST)}
                                </span>
                              </h6>
                              <hr />
                            </div>


                            <div className="container">
                              <form>

                                <div className="mb-3">
                                  <label htmlFor="phoneNumber" className="form-label">
                                    Phone Number:
                                  </label>
                                  <input
                                    type="tel"
                                    className={`form-control ${!phoneNumber && !showOtp && "is-invalid"
                                      }`}
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    value={form.phoneNumber}
                                    onChange={(e) => {
                                      const value = e.target.value.replace(/\D/g, "");
                                      if (value.length <= 10) {
                                        setForm((prev) => ({
                                          ...prev,
                                          phoneNumber: value,
                                        }));
                                      }
                                    }}
                                    maxLength="10"
                                    required
                                    readOnly={!!jwtUser}
                                  />
                                </div>


                                <div className="mb-3">
                                  <label className="form-label">Address:</label>

                                  <input
                                    type="text"
                                    className="form-control mb-2"
                                    placeholder="House / Flat No."
                                    value={form.houseNo}
                                    onChange={(e) =>
                                      setForm((prev) => ({ ...prev, houseNo: e.target.value }))
                                    }
                                    required
                                  />

                                  <input
                                    type="text"
                                    className="form-control mb-2"
                                    placeholder="Area"
                                    value={form.area}
                                    onChange={(e) =>
                                      setForm((prev) => ({ ...prev, area: e.target.value }))
                                    }
                                    required
                                  />

                                  <input
                                    type="text"
                                    className="form-control mb-2"
                                    placeholder="Landmark (Optional)"
                                    value={form.landmark}
                                    onChange={(e) =>
                                      setForm((prev) => ({ ...prev, landmark: e.target.value }))
                                    }
                                  />

                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Pincode"
                                    value={form.pincode}
                                    onChange={(e) => {
                                      const value = e.target.value.replace(/\D/g, "");
                                      if (value.length <= 6) {
                                        setForm((prev) => ({ ...prev, pincode: value }));
                                      }
                                    }}
                                    maxLength="6"
                                    required
                                  />
                                </div>


                                {jwtUser && (
                                  <div className="mb-3">
                                    <label className="form-label fw-bold">Recent Addresses:</label>
                                    {recentAddresses && recentAddresses.length > 0 ? (
                                      <ul className="list-group">
                                        {recentAddresses.map((addr) => (
                                          <li
                                            key={addr._id}
                                            className="list-group-item d-flex justify-content-between align-items-center"
                                          >
                                            <span>
                                              {addr.address}, {addr.pincode}
                                            </span>
                                            <button
                                              type="button"
                                              className="btn btn-sm btn-primary"
                                              onClick={() => {
                                                const parts = addr.address.split(",").map((p) => p.trim());
                                                setForm((prev) => ({
                                                  ...prev,
                                                  houseNo: parts[0] || "",
                                                  area: parts[1] || "",
                                                  landmark: parts[2] || "",
                                                  pincode: addr.pincode || "",
                                                }));
                                              }}
                                            >
                                              Select
                                            </button>
                                          </li>
                                        ))}
                                      </ul>
                                    ) : (
                                      <p className="text-muted">No recent addresses found.</p>
                                    )}
                                  </div>
                                )}

                              </form>
                            </div>


                            <div
                              className="terms-conditions mt-4 p-3 shadow-sm"
                              style={{
                                backgroundColor: "#fff8dc",
                                borderRadius: "10px",
                              }}
                            >

                              <h6 className="font-weight-bold mb-2">
                                {terms?.Message}
                              </h6>
                              <ul
                                style={{
                                  paddingLeft: "20px",
                                  marginBottom: "0",
                                  fontSize: "14px",
                                }}
                              >
                                {terms?.termsConditions?.map((item, index) => (
                                  <li key={index}>{item}</li>
                                ))}
                              </ul>
                            </div>

                          </>
                        )}
                        {/* ✅ Display stock errors inline above Place Order button */}
                        {stockErrors.length > 0 && (
                          <div
                            className="alert alert-danger mt-3"
                            role="alert"
                            style={{
                              borderRadius: "8px",
                              border: "1px solid #f5c6cb",
                              backgroundColor: "#f8d7da",
                              color: "#721c24"
                            }}
                          >
                            <h6 className="alert-heading mb-2">
                              <i className="feather-alert-circle"></i> Stock Unavailable
                            </h6>
                            <ul className="mb-0" style={{ paddingLeft: "20px" }}>
                              {stockErrors.map((error, index) => (
                                <li key={index} style={{ marginBottom: "5px" }}>
                                  <strong>{error.productTitle}</strong>
                                  <br />
                                  <small>
                                    Requested: {error.requested} | Available: {error.available}
                                  </small>
                                </li>
                              ))}
                            </ul>
                            <hr style={{ margin: "10px 0" }} />
                            <small className="mb-0">
                              Please remove or reduce the quantity of out-of-stock items to proceed.
                            </small>
                          </div>
                        )}

                        <div className="d-flex justify-content-center mt-3">
                          {variantCount > 0 && (
                            <button
                              onClick={handlePlaceOrder}
                              type="button"
                              className="btn btn-success btn-lg btn-block"
                            >
                              {hasCustomerInfo
                                ? "Place Order"
                                : "Place Order"}
                            </button>
                          )}
                        </div>
                        {showPlacedOrderSummary && hasCustomerInfo && (
                          <div className="mt-4">
                            <div className="mt-4">
                              {order && order.orderId && (
                                <div
                                  className="fw-bold mb-1"
                                  style={{ color: "dark red" }}
                                >
                                  Order ID: {order.orderId}
                                </div>
                              )}

                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <h5 className="text-success mb-0">
                                  Items Ordered
                                </h5>

                                <button
                                  type="button"
                                  className="btn btn-outline-primary btn-sm"
                                  onClick={handleOrderRefresh}
                                  title="Refresh Order"
                                >
                                  <i className="bi bi-arrow-clockwise me-1"></i>{" "}
                                  Refresh
                                </button>
                              </div>
                            </div>

                            <div className="table-responsive border rounded shadow-sm">
                              <div
                                style={{ maxHeight: "300px", overflowY: "auto" }}
                              >
                                <table className="table table-hover text-center mb-0">
                                  <thead className="table-light sticky-top">
                                    <tr>
                                      <th>Item</th>
                                      <th>Quantity</th>
                                      <th>Status</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {(order?.products?.length > 0
                                      ? order.products
                                      : orderSummary
                                    ).map((item, index) => (
                                      <tr key={index}>
                                        <td style={{ whiteSpace: "pre-wrap" }}>
                                          {item.productTitle?.split(",")[0]}
                                        </td>
                                        <td>{item.quantity}</td>
                                        <td>
                                          <span
                                            className={`badge rounded-pill ${item.status === "delivered"
                                              ? "bg-success"
                                              : item.status === "unavailable"
                                                ? "bg-danger"
                                                : item.status === "readyToDeliver"
                                                  ? "bg-info text-dark"
                                                  : item.status === "processing"
                                                    ? "bg-warning text-dark"
                                                    : "bg-secondary"
                                              }`}
                                          >
                                            {item.status.charAt(0).toUpperCase() +
                                              item.status.slice(1)}
                                          </span>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        )}
                        {!isBillSettled &&
                          order?.products?.every(
                            (item) =>
                              item.status === "delivered" ||
                              item.status === "unavailable"
                          ) && (
                            <div className="d-flex justify-content-end mt-3">
                              <button
                                type="button"
                                className="btn btn-success btn-sm"
                                onClick={handleSettleBill}
                                title="Settle Bill"
                              >
                                Settle Bill
                              </button>
                            </div>
                          )}
                        {isModalVisible && (
                          <div
                            onClick={handleCloseModal}
                            style={{
                              position: "fixed",
                              top: 0,
                              left: 0,
                              width: "100vw",
                              height: "100vh",
                              backgroundColor: "rgba(0, 0, 0, 0.5)",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              zIndex: 1050,
                            }}
                          >
                            <div
                              onClick={(e) => e.stopPropagation()}
                              style={{
                                backgroundColor: "#fff",
                                borderRadius: "8px",
                                width: "90%",
                                maxWidth: "500px",
                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                overflow: "hidden",
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div
                                style={{
                                  padding: "1rem",
                                  backgroundColor: "#f8f9fa",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <h3 style={{ margin: 0 }}>Requested For Bill</h3>
                                <button
                                  onClick={handleCloseModal}
                                  aria-label="Close"
                                  style={{
                                    background: "none",
                                    border: "none",
                                    fontSize: "1.5rem",
                                    color: "#000",
                                    cursor: "pointer",
                                  }}
                                >
                                  &times;
                                </button>
                              </div>
                              <div style={{ padding: "1rem" }}>
                                <p>Hope you enjoyed... See you again! 😊</p>
                              </div>
                              <div
                                style={{
                                  padding: "1rem",
                                  backgroundColor: "#f8f9fa",
                                  textAlign: "right",
                                }}
                              >
                                <button
                                  onClick={handleCloseModal}
                                  style={{
                                    padding: "0.5rem 1rem",
                                    backgroundColor: "#0d6efd",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                  }}
                                >
                                  Close
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      )}

      <div>
        {!show && (
          <div className="container">
            <div
              className="modal modal-sheet position-fixed d-block bg-body-secondary row"
              style={{ zIndex: "1200" }}
            >
              <div className="modal-dialog" role="document">
                <div
                  className="modal-content rounded-4 shadow col-12"
                  style={{
                    height: "660px",
                    width: "540px",
                    overflowY: "auto",
                  }}
                >
                  <div className="modal-header border-bottom-0 text-center">
                    <a
                      onClick={handlehideCart}
                      style={{ color: "darkred", fontSize: "30px" }}
                    >
                      <IoCloseCircle />
                    </a>
                    <h3 className="modal-title fs-5 pt-4 text-center w-100">
                      Order Summary
                    </h3>
                  </div>

                  <div className="modal-body py-0">
                    <h6 className="pb-3 px-3">Your Order</h6>

                    <div className="table-responsive px-3">
                      <table className="table table-bordered">
                        <thead>
                          <tr className="text-center fw-semibold">
                            <th>Image</th>
                            <th>Item</th>
                            <th>Quantity</th>
                            <th>Price</th>
                          </tr>
                        </thead>

                        <tbody className="text-center fw-semibold">
                          {Object.keys(itemQuantities).map((cartKey, index) => {
                            const cartItem = itemQuantities[cartKey];
                            if (!cartItem || !cartItem.variant || cartItem.quantity <= 0)
                              return null;

                            const { productId, variant, quantity } = cartItem;

                            const product =
                              orderSummary.find((p) => p._id === productId) ||
                              cart.find((p) => p._id === productId);

                            const price =
                              variant?.offerPrice ?? variant?.price ?? 0;

                            return (
                              <tr key={cartKey}>

                                <td>
                                  <img
                                    src={
                                      product?.images && product?.images.length > 0
                                        ? `${process.env.REACT_APP_IMAGE_BASE_URL}${product.images[0]}`
                                        : "/default.jpg"
                                    }
                                    alt={product?.productName || "Product"}
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      objectFit: "cover",
                                      borderRadius: "6px",
                                    }}
                                  />
                                </td>

                                <td>
                                  {product?.productName || "Unnamed"},{" "}
                                  {variant?.quantity || "N/A"} {variant?.unit || ""}
                                </td>

                                <td>{quantity}</td>


                                <td>
                                  {price && quantity
                                    ? formatCurrency(price * quantity)
                                    : "N/A"}
                                </td>

                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    {/* Footer Message */}
                    <div className="mt-4 text-center border-top pt-3">
                      <p
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          color: "green",
                          textAlign: "center",
                          textShadow: "0 0 10px rgba(0, 255, 0, 0.8)",
                          animation:
                            "popEffect 1.5s infinite alternate ease-in-out",
                        }}
                      >
                        Order is confirmed! Thank you for shopping with us.
                      </p>

                      {/* Optional Feedback Button */}
                      {/* <button
                className="btn btn-primary mt-3 px-4 py-2"
                onClick={() => {
                  setShowFeedbackPage(true);
                  setShow(true);
                }}
              >
                Give Feedback
              </button> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {showFeedbackPage && (
          <div className="container">
            <div
              className="modal modal-sheet position-fixed d-block bg-body-secondary row"
              style={{ zIndex: "1200" }}
            >
              <div className="modal-dialog" role="document">
                <div
                  className="modal-content rounded-4 shadow col-12"
                  style={{ height: "500px", width: "100%", overflowY: "auto" }}
                >
                  <div className="modal-header border-bottom-0 text-center">
                    <h3 className="modal-title fs-5 pt-4 text-center w-100">
                      Feedback
                    </h3>
                    <a
                      onClick={() => setShowFeedbackPage(false)}
                      style={{ color: "darkred", fontSize: "30px" }}
                    >
                      <IoCloseCircle />
                    </a>
                  </div>

                  <div className="modal-body px-3">
                    <h4 className="mb-4">Feedback</h4>

                    {orderSummary.map((item, index) => {
                      const variant = item.variants?.[0];
                      const feedbackItem = feedback[item._id] || {
                        rating: 0,
                        comment: "",
                      };

                      return (
                        <div
                          key={index}
                          className="card mb-3 p-3 shadow-sm border-0"
                        >
                          <div className="d-flex align-items-center gap-3">
                            <img
                              src={`${process.env.REACT_APP_IMAGE_BASE_URL}${item.imageUrl}`}
                              alt={item.productName}
                              className="rounded"
                              style={{
                                width: "70px",
                                height: "70px",
                                objectFit: "cover",
                                marginRight: "70px",
                              }}
                            />
                            <div className="ms-4" style={{ flex: 1 }}>
                              <h5 className="fw-bold mb-1">
                                {item.productName}
                              </h5>
                              <p className="text-muted mb-1">
                                {variant?.quantity || "N/A"}{" "}
                                {variant?.unit || "N/A"}
                              </p>
                              <p className="fw-semibold">
                                ₹{variant?.price || "N/A"}
                              </p>
                            </div>
                          </div>

                          <div className="mt-3">
                            <p className="fw-semibold mb-1">
                              Rate this product:
                            </p>
                            {[1, 2, 3, 4, 5].map((star) => (
                              <span
                                key={star}
                                onClick={() =>
                                  handleRatingChange(item._id, star)
                                }
                                style={{
                                  cursor: "pointer",
                                  color:
                                    feedbackItem.rating >= star
                                      ? "gold"
                                      : "gray",
                                  fontSize: "30px",
                                }}
                              >
                                ★
                              </span>
                            ))}
                          </div>

                          {feedbackItem.rating > 0 && (
                            <div className="mt-3">
                              <textarea
                                className="form-control"
                                value={feedbackItem.comment}
                                onChange={(e) =>
                                  handleCommentChange(item._id, e.target.value)
                                }
                                required={feedbackItem.rating < 3}
                                placeholder="Write your feedback..."
                                rows="3"
                                style={{
                                  resize: "vertical",
                                  minHeight: "50px",
                                }}
                              ></textarea>
                              {isSubmitting &&
                                feedbackItem.rating < 3 &&
                                !feedbackItem.comment.trim() && (
                                  <div className="text-danger mt-1 fw-bold">
                                    Comment is required for ratings below 3
                                    stars.
                                  </div>
                                )}
                            </div>
                          )}
                        </div>
                      );
                    })}

                    <div className="text-center">
                      <button
                        className="btn btn-primary btn-sm mt-3 px-3 py-1"
                        onClick={handleSubmitFeedback}
                      >
                        Submit Feedback
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </SnackbarProvider>
  );
};
export default CartBox;

